'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'house-chimney';
var width = 576;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M96 214.7L288 45.3 480 214.7l0 257c-2.3 3-4.9 5.7-7.7 8.2L368 480l0-176c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16l0 176-106.1 0c-2.1-1.9-4-3.8-5.9-6l0-259.3zM416 64l64 0 0 108.1-64-56.5L416 64z', 'M288 2.7L298.6 12 384 87.4 384 48l0-16 16 0 96 0 16 0 0 16 0 152-.3 0 58.9 52-21.2 24L512 243l0 253 0 16-16 0L80 512l-16 0 0-16 0-253L26.6 276 5.4 252l272-240L288 2.7zM480 172.1L480 64l-64 0 0 51.6 64 56.5zM96 214.7L96 480l112 0 0-176c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 176 112 0 0-265.3L288 45.3 96 214.7zM336 320l-96 0 0 160 96 0 0-160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;